const getProfileHeroColor = (baseColor, profile) => {
  let bgColor = baseColor

  if (profile) {
    bgColor = 'light-green'

    const title = profile.title ? profile.title : profile

    switch (title) {
      case 'Riverain':
        bgColor = 'blue'
        break
      case 'Neighbour':
        bgColor = 'blue'
        break
      case 'Investisseur':
        bgColor = 'medium-green-2'
        break
      case 'Investor':
        bgColor = 'medium-green-2'
        break
      case 'Collectivité':
        bgColor = 'purple'
        break
      case 'Local authority':
        bgColor = 'purple'
        break
      default:
        break
    }
  }

  return bgColor
}

export default getProfileHeroColor
